var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M9.98505 17.2337C11.5396 17.2337 12.8799 16.6892 14.006 15.6C15.132 14.5108 15.6951 13.2145 15.6951 11.7108C15.6951 10.2072 15.132 8.91566 14.006 7.83614C12.8799 6.75663 11.5396 6.21687 9.98505 6.21687C8.43049 6.21687 7.09517 6.75663 5.97907 7.83614C4.86298 8.91566 4.30493 10.2072 4.30493 11.7108C4.30493 13.2145 4.86298 14.5108 5.97907 15.6C7.09517 16.6892 8.43049 17.2337 9.98505 17.2337ZM12.1973 14.7759L9.14798 12.0578V7.98072H10.583V11.6241L13.154 13.8506L12.1973 14.7759ZM9.98505 24C7.07524 23.2867 4.68361 21.6627 2.81016 19.1277C0.936721 16.5928 0 13.812 0 10.7855V3.61446L9.98505 0L20 3.61446V10.7855C20 13.812 19.0583 16.5928 17.1749 19.1277C15.2915 21.6627 12.8949 23.2867 9.98505 24ZM9.98505 21.6289C12.2172 20.8578 14.0458 19.4795 15.4709 17.494C16.8959 15.5084 17.6084 13.2723 17.6084 10.7855V5.23374L9.98505 2.45783L2.36173 5.23374V10.7855C2.36173 13.2723 3.07424 15.5084 4.49925 17.494C5.92426 19.4795 7.75287 20.8578 9.98505 21.6289Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessManagement);
export default __webpack_public_path__ + "static/media/accessManagement.4c054f1739979ae68f415d12d0dc954e.svg";
export { ForwardRef as ReactComponent };